import { Box, Text, Card, Flex, Center } from "@chakra-ui/react";
import { AddButton } from "../assets/svgs/Icons";
import { useNavigate } from "react-router-dom";

export const AddProcurementCard = () => {
  const navigate = useNavigate();
  return (
    <Box margin={"1rem"}>
      <Flex flexDirection={"column"}>
        <Box margin={"0.5rem"}>
          <Flex justifyContent={"space-between"}>
            <Text fontSize={"19px"} fontWeight={"800"} color={"brand.blue"}>
              Add Procurement
            </Text>
          </Flex>
        </Box>
        <Flex>
          <Flex
            w={"304px"}
            h={"182px"}
            boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
            bg={"brand.white"}
            borderRadius={"15px"}
            justifyContent={"center"}
            alignItems={"center"}
            cursor="pointer"
            onClick={() => navigate("/procurement/procurement-form")}
          >
            <Box>
              <AddButton w="44px" h="44px" />
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};
